import React, { createContext, useContext, useEffect, useMemo, useReducer } from "react";
import { ParentContext } from "../../../../global/cnr/contexts/ParentContext";
import { seasonMatchesHandlers, seasonMatchesInitialState, seasonMatchesReducer } from "../reducers/SeasonMatchesReducer";
import { SportsSeasonContext, matchScheduleTypes } from "./SportsSeasonContext";
import { useAppUserAccess } from "global/cnr/contexts/useHelpers/useAppUserAccess";

export const SeasonMatchesContext = createContext()

const _cnEditTypes = {
  allowMatchEdit: 'ame',
  allowScoreEdit: 'ase',
  allowAdminMatchEdit: 'aame'
}

export default function SeasonMatchesProvider(props) {

  // TOURNAMENT
  // tournamentType={tournamentType}
  // poolMatches={matches}
  // pools={pools}
  // poolKey={item_pool}
  // isTournament={true}
  // viewItem={viewItem}
  // handleMatchClick={handleMatchClick}

  // PLAYOFFS
  // poolMatches={matches}
  // pools={pools_init}
  // isTournament={true}
  // viewItem={viewItem}
  // handleMatchClick={handleMatchClick}
  // tournamentType={tournamentType}
  // forPlayoff={true}
  // poolKey={p}

  // matchScheduleDisplayType, scheduleDisplayType

  const {
    commonMatches,
    forBackup,
    forOverview,
    forPlayoff,
    forSummary,
    latestMatchesCount,
    matchScheduleDisplayType,
    matchScheduleType,
    poolKey,
    poolMatches,
    pools,
    previewMatches,
    scheduleDisplayType,
    teamKey,
    tournamentType,
    directMatches,
  } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { appUser_state, paps_state } = states
  const { appUsers } = appUser_state ?? {}
  const { navigation_fns } = fns
  const { pathViews } = paps_state ?? {}

  const appUserAccess = useAppUserAccess()
  const { itemAccess } = appUserAccess ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_fns } = sportsSeasonContext ?? {}
  const { matches_info, seasonMatches_info, sportPermissions } = sportsSeason_state ?? {}

  const _matches_info = forBackup && seasonMatches_info ? seasonMatches_info : matches_info

  const _teamKey = teamKey ? teamKey : pathViews.teams

  const scheduleTypes = {
    district: pathViews && pathViews.districts && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    match: pathViews && pathViews.matches ? true : false,
    sport: pathViews && pathViews.sports ? true : false,
    team: teamKey || (pathViews && pathViews.teams) ? true : false,
    common: commonMatches ? true : false
  }

  let _sepBySection = true
  if (scheduleTypes.team || scheduleTypes.match || scheduleTypes.common) {
    _sepBySection = false
  }

  const seasonMatches_fns = {
    getMatchCn: (match, matchAllows, _sportSeasonSettings, tournamentType, playoffDates, matchResultFullBackground) => {

      let _sportsMatch_cn = 'schedule-match'

      if (!match) { return _sportsMatch_cn }

      const {
        _resultsStatus,
        _results_matchDay,
        _results,
        _status,
        away,
        home,
        id,
        isPlayoff,
        key,
        location,
        pending,
      } = match ?? {}

      // NEW STUFF
      const { winner, scoreDisplays, complete, tied } = _results ?? {}

      const { edit: _allowEdit_match, scores: _allowEdit_scores, matchAccessLevel } = matchAllows ?? {}
      const { scoreType } = _resultsStatus ?? {}

      const { home: home_pending, away: away_pending } = pending ?? {}

      let loc = location ? location.name : null

      let _home = home
      let _away = away

      if (home_pending) { _home = home_pending }
      if (away_pending) { _away = away_pending }

      const { isFuture, isMissing, isPast, isBye } = _status ?? {}
      const isPending = (!home || !away) ? true : false
      const teamIsHome = _home.id === _teamKey

      const _isPlayoff = false
      const keyy = key ? key : id

      if (matchScheduleType === matchScheduleTypes.latest) { _sportsMatch_cn += ' lmo' }
      if (_sportSeasonSettings && _sportSeasonSettings.useScoreBlock) { _sportsMatch_cn += ' blocked' }
      if (complete) { _sportsMatch_cn += ' complete' }

      if (tournamentType) {
        _sportsMatch_cn += ' pool'
      } else if (scheduleTypes.match) {
        _sportsMatch_cn += ' match'
      } else if (scheduleTypes.team && !_isPlayoff) {
        _sportsMatch_cn += ' teams'
      } else {
        _sportsMatch_cn += ' section'
      }

      if (matchResultFullBackground) { _sportsMatch_cn += ' fmrb' }

      if (playoffDates || isPlayoff) {
        _sportsMatch_cn += ' playoff'
      }

      const allowMatchEdits = { match: false, sport: false, any: false }

      allowMatchEdits.match = (itemAccess && ((_home && itemAccess.includes(_home.id)) || (_away && itemAccess.includes(_away.id)))) ? true : false
      allowMatchEdits.sport = (itemAccess && itemAccess.includes(sportsKey)) ? true : false


      const _scoreDisplays = scoreDisplays
      let { scores: scoreDisplay_scores } = _scoreDisplays ?? {}

      if (winner) {
        _sportsMatch_cn += winner.id === _teamKey ? ' win' : ' loss'
        _sportsMatch_cn += winner.id === home.id ? ' wh' : ' wa'
      }

      if (tied && tied.length === 2) {
        _sportsMatch_cn += ' tie'
      }

      if (isFuture) { _sportsMatch_cn += ' future' }
      // if (complete) { _sportsMatch_cn += ' complete' }
      if (allowMatchEdits.any) { _sportsMatch_cn += ' ' + _cnEditTypes.allowMatchEdit } // ame
      if (allowMatchEdits.sport) { _sportsMatch_cn += ' ' + _cnEditTypes.allowScoreEdit } // ase
      if (_allowEdit_scores && !forOverview) { _sportsMatch_cn += ' ' + _cnEditTypes.allowAdminMatchEdit } // aame was ae
      if (matchAccessLevel) { _sportsMatch_cn += ' mal-' + matchAccessLevel }
      if (isBye) { _sportsMatch_cn += ' bye' }
      if (isPast && !winner && !_results_matchDay) { _sportsMatch_cn += ' no-res' }
      if (isPending) { _sportsMatch_cn += ' pending' }
      if (isMissing && !_results_matchDay) { _sportsMatch_cn += ' missing' }
      if (loc === _home.name) { _sportsMatch_cn += ' lch' }
      if (scoreType) { _sportsMatch_cn += ' ' + scoreType }

      if (teamIsHome) {
        _sportsMatch_cn += ' tih'
      } else {
        _sportsMatch_cn += ' tia'
      }

      if (scoreDisplay_scores && !forOverview) { _sportsMatch_cn += ' scrs' }

      return _sportsMatch_cn
    }
  }

  // sidebar
  const init = {
    _teamKey,
    directMatches,
    commonMatches,
    latestMatchesCount,
    matchScheduleType,
    scheduleDisplayType,
    matchScheduleDisplayType,
    matchesInfo: _matches_info,
    pathViews,
    previewMatches,
    navigation_fns,
    scheduleTypes,
    sepBySection: _sepBySection,
    sportsSeason_fns,
    sportPermissions,
    tournamentType,
    forPlayoff,
    forSummary
  }

  const [seasonMatches_state, seasonMatches_dispatch] = useReducer(seasonMatchesReducer, seasonMatchesInitialState(init));
  const seasonMatches_handlers = useMemo(
    () => seasonMatchesHandlers(seasonMatches_dispatch),
    [seasonMatches_dispatch]
  );

  // update the scheduledMatches
  useEffect(() => {
    if (_matches_info) {
      seasonMatches_handlers.handleMatches_init(_matches_info, commonMatches)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [pathViews, _matches_info, matchScheduleType, commonMatches]);

  useEffect(() => {
    if (pools && poolMatches) {
      seasonMatches_handlers.handleMatches_initPlayoff(pools, poolMatches)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [pathViews, poolMatches, pools]);

  return <SeasonMatchesContext.Provider
    value={{ seasonMatches_state, seasonMatches_handlers, seasonMatches_fns }}>
    {props.children}
  </SeasonMatchesContext.Provider>
}